import { isEqual } from "lodash";
import { sitesPipelineStore } from "../store";
import { SitesByStage } from "react-migration/domains/sites";

export const handleSitesByStageUpdateFromVue = (sitesByStage: SitesByStage) => {
  sitesPipelineStore.vueSitesByStage = sitesByStage;

  // We need to use `getOwnPropertyNames` here because the `sitesByStage` object coming through from vue only has getters
  Object.getOwnPropertyNames(sitesByStage).forEach((stageId) => {
    const sites = sitesByStage[stageId];
    const siteIds = Array.isArray(sites) ? sites.map((site) => site._id) : [];

    if (!isEqual(siteIds, sitesPipelineStore.orderedSiteIdsByStageId[stageId])) {
      sitesPipelineStore.orderedSiteIdsByStageId[stageId] = siteIds;
    }

    if (sites.length) {
      sites.forEach((site) => {
        if (!isEqual(site, sitesPipelineStore.siteBySiteId[site._id])) {
          sitesPipelineStore.siteBySiteId[site._id] = site;
        }
      });
    }
  });
};
